import { useCallback, useEffect } from "react";
import maplibregl from "maplibre-gl";
import { useTranslation } from "react-i18next";
import { metersToKm } from "src/services/metersToKm";

const useMapPopups = (map, mapPoints, showPopup, distanceForEachPoint) => {
	const { t } = useTranslation();

	const generatePopupHtml = (address, distance) => {
		return `
			<div class="popup-container">
				<div class="popup-address">
					<span>${address}</span>
				</div>
				<div class="popup-circle">
					<div class="popup-distance">
						<p>${distance}</p>
						<p>${t("km")}</p>
					</div>
				</div>
			</div>`;
	}

	useEffect(() => {
		if (!map || !Array.isArray(mapPoints) || !showPopup) {
			return
		}

		const [firstPoint, lastPoint] = [
			mapPoints[0],
			mapPoints[mapPoints.length - 1],
		];

		const [firstDistance, lastDistance] = [
			metersToKm(distanceForEachPoint?.driverToClient),
			metersToKm(distanceForEachPoint?.startToFinish),
		];

		const popupOptions = {
			closeButton: false,
			closeOnClick: false,
			anchor: "bottom",
			className: "custom-popup",
			offset: [12, -13],
		};

		const createPopup = (point, distance) => {
			return new maplibregl.Popup(popupOptions)
				.setHTML(generatePopupHtml(point.mainText, distance))
				.setLngLat([point.lon, point.lat])
				.addTo(map);
		};

		const firstPointPopup = createPopup(firstPoint, firstDistance);
		const lastPointPopup = createPopup(lastPoint, lastDistance);

		return () => {
			firstPointPopup.remove();
			lastPointPopup.remove();
		};
	}, [distanceForEachPoint, generatePopupHtml, map, mapPoints, showPopup]);
};

export default useMapPopups;
